import { Color } from '../types/ColorLibraryModel';

export const hexToRgb = (hex: string): number[] => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [0, 0, 0];
};

export const isColorDark = (hexCode: string): boolean => {
  const rgb = hexToRgb(hexCode);
  const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
  return brightness < 128;
};

export const colorFromBgColor = (hexCode: string, opacity = 1): string => {
  return isColorDark(hexCode) ? `rgba(255, 255, 255, ${opacity})` : `rgba(0, 0, 0, ${opacity})`;
};

export const addHSPValue = (colors: Color[]): Color[] => {
  return colors.map((c) => {
    if (c.hexCode === '') {
      return c;
    }
    const rgb = +(
      '0x' +
      c.hexCode.slice(1).replace(c.hexCode.length < 5 ? /./g : '', '$&$&')
    );

    const r = rgb >> 16;
    const g = (rgb >> 8) & 255;
    const b = rgb & 255;

    const hsp = Math.sqrt(
      0.241 * (r * r) + 0.691 * (g * g) + 0.068 * (b * b),
    );

    return {
      ...c,
      rgb,
      hsp: +hsp.toFixed(4),
    };
  });
};

export const sortByHSP = (colors: Color[], darkToLight = true): Color[] => {
  let group = null;
  let index = 0;
  const groupNames: string[] = [];
  const localArray: Color[][] = [];

  for (let i = 0; i < colors.length; i++) {
    group = colors[i].group;
    index = groupNames.indexOf(group);
    if (index === -1) {
      groupNames.push(group);
    }
  }

  groupNames.forEach((groupName) => {
    localArray.push(
      colors
        .filter((c) => c.group === groupName)
        .sort((a, b) => (darkToLight ? (a.hsp || 0) - (b.hsp || 0) : (b.hsp || 0) - (a.hsp || 0)))
    );
  });

  const result: Color[] = [];
  localArray.forEach((group) => {
    group.forEach((colour) => {
      result.push(colour);
    });
  });

  return result;
};

export const sortByGrayScale = (colors: Color[], activeSorting: { code: string }): Color[] => {
  const processedColors = addHSPValue(colors);
  return sortByHSP(processedColors, activeSorting.code === 'darktoLight');
};
